(() => {
  if (window.__epProduct) return;
  window.__epProduct = true;

  const money = (cents, format) => {
    const n = Number(cents) / 100;
    const whole = Number.isInteger(n);
    const withCommas = (v, d) => v.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amount = whole ? withCommas(n, 0) : withCommas(n, 2);
    return String(format || 'Rs. {{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator') return withCommas(Math.round(n), 0);
      if (key === 'amount_with_comma_separator') return amount.replace('.', ',');
      return amount;
    });
  };

  /* ---------- Gallery ---------- */
  const initGallery = (root) => {
    const gallery = root.querySelector('[data-ep-gallery]');
    if (!gallery || gallery.__ep) return;
    gallery.__ep = true;
    const track = gallery.querySelector('[data-ep-slides]');
    const slides = [...track.children];
    const thumbs = [...gallery.querySelectorAll('[data-ep-thumb]')];
    const counter = gallery.querySelector('[data-ep-current]');
    let index = 0;

    const setActive = (i) => {
      index = i;
      slides.forEach((s, n) => s.toggleAttribute('aria-hidden', n !== i));
      thumbs.forEach((t, n) => {
        if (n === i) {
          t.setAttribute('aria-current', 'true');
          const strip = t.closest('.ep-pd__thumbs');
          if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        } else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = i + 1;
      gallery.classList.toggle('is-first', i === 0);
      gallery.classList.toggle('is-last', i === slides.length - 1);
      slides.forEach((s, n) => { if (n !== i) s.querySelectorAll('video').forEach((v) => v.pause()); });
    };
    const go = (i, smooth = true) => {
      const n = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(n);
    };
    gallery.__go = go;

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && slides[i]) setActive(i);
      });
    }, { passive: true });

    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-ep-thumb]');
      if (thumb) return go(Number(thumb.dataset.epThumb));
      if (e.target.closest('[data-ep-prev]')) return go(index - 1);
      if (e.target.closest('[data-ep-next]')) return go(index + 1);
      const zoom = e.target.closest('[data-ep-zoom]');
      if (zoom) openLightbox(root, Number(zoom.dataset.epZoom));
    });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });
    setActive(0);
  };

  const openLightbox = (root, i) => {
    const dialog = root.querySelector('[data-ep-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    dialog.showModal();
    document.documentElement.classList.add('ep-lb-open');
    const item = dialog.querySelector(`[data-ep-lb-item="${i}"]`);
    if (item) requestAnimationFrame(() => item.scrollIntoView({ block: 'start' }));
  };
  document.addEventListener('click', (e) => {
    const dialog = e.target.closest('[data-ep-lightbox]');
    if (!dialog) return;
    if (e.target.closest('[data-ep-lb-close]') || e.target === dialog || e.target.closest('img')) dialog.close();
  });
  document.addEventListener('close', (e) => {
    if (e.target.matches && e.target.matches('[data-ep-lightbox]')) document.documentElement.classList.remove('ep-lb-open');
  }, true);

  /* ---------- Variants, quantity, buttons ---------- */
  const initBuy = (root) => {
    const dataEl = root.querySelector('[data-ep-product]');
    const form = root.querySelector('form.ep-pd__form');
    if (!dataEl || !form || form.__ep) return;
    form.__ep = true;
    const data = JSON.parse(dataEl.textContent);
    const idInput = form.querySelector('[data-ep-variant-id]');
    const fieldsets = [...form.querySelectorAll('[data-ep-option]')];
    const atc = form.querySelector('[data-ep-atc]');
    const atcLabel = form.querySelector('[data-ep-atc-label]');
    const buy = form.querySelector('[data-ep-buy]');
    const els = {
      now: root.querySelector('[data-ep-now]'),
      was: root.querySelector('[data-ep-was]'),
      off: root.querySelector('[data-ep-off]'),
      offTag: root.querySelector('[data-ep-off-tag]'),
      save: root.querySelector('[data-ep-save]'),
      saveAmt: root.querySelector('[data-ep-save-amt]'),
    };
    const selected = () => fieldsets.map((fs) => {
      const c = fs.querySelector('input[data-ep-value]:checked');
      return c ? c.value : null;
    });
    const find = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const refreshAvailability = (opts) => {
      fieldsets.forEach((fs, i) => {
        fs.querySelectorAll('input[data-ep-value]').forEach((input) => {
          const test = opts.slice();
          test[i] = input.value;
          const v = find(test);
          input.closest('.ep-pd__pill').classList.toggle('is-unavailable', !v || !v.available);
        });
        const label = fs.querySelector('[data-ep-opt-value]');
        if (label) label.textContent = opts[i] || '';
      });
    };

    const update = (variant, opts) => {
      refreshAvailability(opts);
      if (!variant) {
        atc.disabled = true;
        buy.disabled = true;
        atcLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      idInput.disabled = !variant.available;
      atc.disabled = !variant.available;
      buy.disabled = !variant.available;
      atcLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';

      const onSale = variant.compare > variant.price;
      const off = onSale ? Math.floor(((variant.compare - variant.price) * 100) / variant.compare) : 0;
      if (els.now) els.now.textContent = money(variant.price, data.money);
      if (els.was) {
        els.was.hidden = !onSale;
        els.was.lastChild.textContent = money(variant.compare, data.money);
      }
      if (els.off) { els.off.hidden = off < 1; els.off.textContent = `${off}% off`; }
      if (els.offTag) { els.offTag.hidden = off < 5; els.offTag.textContent = `${off}% off`; }
      if (els.save) { els.save.hidden = !onSale; els.saveAmt.textContent = money(variant.compare - variant.price, data.money); }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', url.toString());

      if (variant.media) {
        const gallery = root.querySelector('[data-ep-gallery]');
        const slide = gallery && gallery.querySelector(`[data-media-id="${variant.media}"]`);
        if (slide && gallery.__go) gallery.__go(Number(slide.dataset.index));
      }

      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
    };

    form.addEventListener('change', (e) => {
      const input = e.target.closest('input[data-ep-value]');
      if (!input) return;
      const opts = selected();
      let variant = find(opts);
      if (!variant) {
        const i = fieldsets.indexOf(input.closest('[data-ep-option]'));
        variant = data.variants.find((v) => v.options[i] === input.value && v.available) || data.variants.find((v) => v.options[i] === input.value);
        if (variant) {
          variant.options.forEach((val, n) => {
            const r = fieldsets[n] && [...fieldsets[n].querySelectorAll('input[data-ep-value]')].find((x) => x.value === val);
            if (r) r.checked = true;
          });
        }
      }
      update(variant, variant ? variant.options : opts);
    });

    const qty = form.querySelector('input[name="quantity"]');
    form.addEventListener('click', (e) => {
      const step = e.target.closest('[data-ep-qty-step]');
      if (step) {
        const next = Math.max(1, Math.min(Number(qty.max) || 99, (Number(qty.value) || 1) + Number(step.dataset.epQtyStep)));
        qty.value = next;
        qty.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }
      if (e.target.closest('[data-ep-buy]')) {
        e.preventDefault();
        buyNow(form);
      }
    });

    refreshAvailability(selected());
  };

  const buyNow = async (form) => {
    const buy = form.querySelector('[data-ep-buy]');
    const sticky = document.querySelector('#akilli-sticky-cart-root [data-akilli-sc-buy]');
    if (sticky && !sticky.disabled) return sticky.click();
    const shiprocket = form.querySelector('.shiprocket-headless button, button.sr-headless-checkout');
    if (shiprocket) return shiprocket.click();
    buy.classList.add('is-busy');
    try {
      await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: Number(form.querySelector('[name="quantity"]').value) || 1 }] }),
      });
      window.location.href = '/checkout';
    } catch (err) {
      buy.classList.remove('is-busy');
    }
  };

  /* ---------- Size guide shortcut ---------- */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-ep-open-guide]')) return;
    const trigger = document.querySelector('.ep-pd__guide button, .ep-pd__guide a, .ep-pd__guide [role="button"]');
    if (trigger) trigger.click();
    else {
      const guide = document.querySelector('.ep-pd__opt');
      if (guide) guide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---------- Mobile buy bar: shown once the main buttons scroll away ---------- */
  const initStickyWatch = (root) => {
    const actions = root.querySelector('.ep-pd__actions');
    if (!actions) return;
    const html = document.documentElement;
    html.classList.add('ep-pd-page');
    let ticking = false;
    const check = () => {
      ticking = false;
      html.classList.toggle('ep-buy-away', actions.getBoundingClientRect().bottom < 0);
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  };

  /* ---------- Reviews: reveal the rest of the list ---------- */
  document.addEventListener('click', (e) => {
    const more = e.target.closest('[data-ep-rv-more]');
    if (!more) return;
    const rv = more.closest('.ep-rv');
    rv.classList.add('is-open');
    const next = rv.querySelector('.akilli-reviews-grid-masonry > .akilli-review-card:nth-child(n+5)');
    if (next) {
      next.setAttribute('tabindex', '-1');
      next.focus({ preventScroll: true });
    }
  });

  /* ---------- Offers: drop the block if the offers app has nothing to show ---------- */
  const watchOffers = (root) => {
    const block = root.querySelector('.ep-pd__offers');
    if (!block) return;
    const check = () => { if (!block.querySelector('#akilli-offer-widget')) block.classList.add('is-empty'); };
    if (document.readyState === 'complete') setTimeout(check, 6000);
    else window.addEventListener('load', () => setTimeout(check, 6000), { once: true });
  };

  /* ---------- Recommendations ---------- */
  const initRecs = (el) => {
    if (!el || el.__ep || !el.dataset.url) return;
    el.__ep = true;
    const load = () => fetch(el.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-ep-recs]');
        if (!fresh || !fresh.innerHTML.trim()) { el.closest('.shopify-section').hidden = true; return; }
        el.innerHTML = fresh.innerHTML;
        el.classList.add('is-loaded');
        el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(() => {});
    if (!('IntersectionObserver' in window)) return load();
    const io = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      load();
    }, { rootMargin: '0px 0px 700px 0px' });
    io.observe(el);
  };

  const init = (scope) => {
    scope.querySelectorAll('.ep-pd').forEach((root) => {
      initGallery(root);
      initBuy(root);
      initStickyWatch(root);
      watchOffers(root);
    });
    scope.querySelectorAll('[data-ep-recs]').forEach(initRecs);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => { if (!e.target.matches('[data-ep-recs]')) init(e.target); });
})();
